<div class="dialog-header">
  <h2>Benefit Usage History</h2>
</div>

<div class="dialog-body">
  <table>
    <thead>
      <tr>
        <th>Usage Date</th>
        <th>Benefit</th>
        <th>Branch</th>
        <th>Request Creator</th>
        <th>Request Invoice</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of dataSource">
        <td>{{ row.usageDate }}</td>
        <td>{{ row.benefit }}</td>
        <td>{{ row.branch }}</td>
        <td>{{ row.requestCreator }}</td>
        <td>{{ row.requestInvoice }}</td>
      </tr>
      <tr *ngIf="dataSource.length === 0">
        <td colspan="5" class="empty">No records found.</td>
      </tr>
    </tbody>
  </table>
</div>

<div class="dialog-footer">
  <button class="close-btn" (click)="close()">Close</button>
</div>
